import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import { DropBoxPresignedUrlUploadResponse } from '../../api-models';
import BaseAdapter from './baseAdapter';
import { DropBoxUploadFileResponse } from '../../types/dropBox.type';

export default class PostDropBoxUpload extends BaseAdapter<DropBoxPresignedUrlUploadResponse> implements AdapterInterface {
  rawResponse: DropBoxPresignedUrlUploadResponse;

  async adaptResponse(request: { fileName: string, contentType: string }): Promise<DropBoxUploadFileResponse> {
    await this.fetchApiResponse('/api/drop-box/upload', HTTPMethod.Post, {
      file_name: request.fileName,
      content_type: request.contentType,
    });
    return {
      presignedUrl: this.rawResponse.presigned_url,
      s3Key: this.rawResponse.s3_key,
      uploadedBy: this.rawResponse.uploaded_by,
      fileName: this.rawResponse.file_name,
    };
  }
}
